
/*
Defines the custom element <ravel-field-recorder>
*/

import { RavelFieldRecorder } from './src/RavelFieldRecorder.js';

customElements.define('ravel-field-recorder', RavelFieldRecorder);
